import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var LoadingButton = require("components/utility/LoadingButton");
var ButtonDropdown = require("components/utility/ButtonDropdown");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

@connect(
	(state, props) => {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {}
		var admin = RosterSelectors.admin({state, id: CurrentUser.get().id})
		
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}

		return {
			prefs
		}
	},

	(dispatch, props) => ({
		populateData: () => {
            //STEP 1: Grab logged in admin
            return Promise.all([ dispatch(RosterActions.fetchAdmins({
                filters:{ids: [CurrentUser.get().id]}, 
                embeds:['user.prefs'],
                cache: true
            }))])
        },
		onChange: (prefsUpdate, message) => {
			
			// RESETING ALL STUDENT LISTS
			var resetStudentLists = false

			if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.ass-specific setting previously selected.") == true) {
				resetStudentLists = true
			} 

			window.wrNotifications.triggerDropDownNotification({
				title: "Information Edited", text: message, icon: "ok-sign"
			});

			return dispatch( RosterActions.updateAdminPrefs({
				id: CurrentUser.get().id,
				resetStudentLists: resetStudentLists,
				update: prefsUpdate
			}))
		},

	})
)

@providePopulateData({waitForLoad:true})
class QuizScoringPreference extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("QuizScoringPreference");
	}

	onPassingThresholdChange(value) {
		var prefsHash = { passing_threshold: value }
		this.props.onChange(prefsHash, "You successfully changed the minimum passing score.");
	}

	onViewableScoresChange(value) {
		var prefsHash = { visible_student_scores: value }
		this.props.onChange(prefsHash, "You successfully changed the visibility of scores.");
	}

	scoreCap() {
		return this.props.prefs.display_score_cap;
	}

	render() {
		var scoringOptions = _.map(THRESHOLD_OPTIONS, function(threshold) {
			var text = (threshold * this.scoreCap()) + "/" + this.scoreCap();
			return (
				<div key={ threshold }> 
					<label>
						<input type="radio" onChange={ this.onPassingThresholdChange.bind(this, threshold) }
							checked={ this.props.prefs.passing_threshold === threshold } /> 
						{ text }
					</label>
				</div>
			);
		}.bind(this));

		var currentScoreThreshold = this.props.prefs.passing_threshold * this.scoreCap();
		var currentText = "Minimum Passing Score: " + currentScoreThreshold + "/" + this.scoreCap();

		return (
			<div className="quizScoringSettingContainer">
				<p className="subTitle">Minimum Passing Score</p>
				<p>
					Adjust the minimum
					number of points required to pass quizzes to make the autograder
					easier or harder on your students.
				</p>
				<p className="selectScoringText">
					<b>Note:</b> This setting will affect the scoring of quizzes already taken.
				</p>
				
				{ scoringOptions }
				<div className="viewableScoreOptions">
					<p className="subTitle">Show Scores to Students</p>
					<label>
						<input type="radio" onChange={ this.onViewableScoresChange.bind(this, true) }
							checked={ this.props.prefs.visible_student_scores === true } />
						Show scores to students
					</label><br />
					<label>
						<input type="radio" onChange={ this.onViewableScoresChange.bind(this, false) }
							checked={ this.props.prefs.visible_student_scores === false } />
						Do not show scores to students
					</label>
				</div>
			</div>
		)
	}
}


var THRESHOLD_OPTIONS = [0.5, 0.625, 0.75, 0.875, 1.0]

QuizScoringPreference.WrappedComponent.propTypes = StrictPropTypes({
	// Data from @connect
	prefs: PropTypes.object,

	// Handlers from @connect
	onChange: PropTypes.func.isRequired,
	populateData: PropTypes.func.isRequired
});

module.exports = QuizScoringPreference;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/QuizScoringPreference.js